import {
  PLANNER_ELEMENT_DP_CAS_SERVICE_TYPES,
  PLANNER_ELEMENT_DP_CAS_STRANDS,
  PLANNER_ELEMENT_DP_CAS_APPROACHES,
  PLANNER_ELEMENT_DP_CP_SL_APPROACHES,
  PLANNER_ELEMENT_DP_CP_SL_STRANDS,
  PLANNER_ELEMENT_MYP_SERVICE_ACTION_TYPE,
} from "Constants/stringConstants";

export const PROJECT_GROUP_TYPE_COMMUNITY = "COMMUNITY";
export const PROJECT_GROUP_TYPE_PERSONAL = "PERSONAL";
export const PROJECT_GROUP_TYPE_SERVICE_AS_ACTON = "SERVICE_AS_ACTION";
export const PROJECT_GROUP_TYPE_DP_CAS = "DP_CAS";
export const PROJECT_GROUP_TYPE_DP_TOK = "DP_TOK";
export const PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION = "DP_TOK_EXHIBITION";
export const PROJECT_GROUP_TYPE_DP_TOK_ESSAY = "DP_TOK_ESSAY";
export const PROJECT_GROUP_TYPE_DP_EE = "DP_EE";
export const PROJECT_GROUP_TYPE_DP_G4_PROJECT = "DP_G4_PROJECT";
export const PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT =
  "DP_COLLABORATIVE_SCIENCES_PROJECT";
export const PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT = "CP_REFLECTIVE_PROJECT";
export const PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING = "CP_SERVICE_LEARNING";
export const PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT = "COMMUNITY_ENGAGEMENT";

export const PLANNER_ELEMENT_TYPE_DP_EE_CATEGORY = "DP_EE_CATEGORY";
export const PLANNER_ELEMENT_TYPE_DP_EE_GLOBAL_THEME = "DP_EE_GLOBAL_THEME";

export const PORTFOLIO_LEARNING_OUTCOMES_MAP = {
  [PROJECT_GROUP_TYPE_DP_CAS]: "DP_CAS_LEARNING_OUTCOMES",
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: "DP_CP_SL_LEARNING_OUTCOMES",
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: "MYP_SERVICE_ACTION_OUTCOME",
  [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT]: "CE_LEARNING_OUTCOMES",
};

export const PROJECT_PORTFOLIO_TYPE = {
  [PROJECT_GROUP_TYPE_DP_CAS]: "project:cas",
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: "project:sl",
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: "project:saa",
  [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT]: "project:ce",
};

export const PROJECT_COORDINATOR_ROLE = "PROJECT_COORDINATOR";

export const PROJECT_GROUP_TYPE_REJECTION_DELETION_LABELS = {
  [PROJECT_GROUP_TYPE_DP_CAS]: "project:cas_experience",
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]:
    "project:service_learning_experience",
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: "project:service_activity_lowercase",
  [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT]: "project:engagement_lowercase",
  [PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT]:
    "project:project_lowercase",
};

export const PROJECT_GROUP_PROJECTS_LABELS = {
  [PROJECT_GROUP_TYPE_DP_CAS]: "project:experience",
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: "project:experience",
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: "project:activity",
  [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT]: "project:engagement",
};

export const PROJECT_GROUP_COMPLETED_BANNER_DISPLAY_NAME = {
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: "project:service_activity",
};

export const PROJECT_ARCHIVAL_STATES = {
  ALL: "ALL",
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
};

export const PROJECT_ARCHIVAL_STATE_LABELS = {
  [PROJECT_ARCHIVAL_STATES.ALL]: "common:all",
  [PROJECT_ARCHIVAL_STATES.ACTIVE]: "common:active",
  [PROJECT_ARCHIVAL_STATES.ARCHIVED]: "common:archived",
};

export const PROJECT_PORTFOLIO_TYPE_TOTAL_LOS_COUNT = {
  [PROJECT_GROUP_TYPE_DP_CAS]: 7,
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: 5,
  [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT]: 4,
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: 7,
};

export const PROJECT_GROUP_TEMPLATE_IDS_MAP = {
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: "toddle_myp_service_as_action",
  [PROJECT_GROUP_TYPE_DP_CAS]: "toddle_dp_cas_project_experience",
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: "cp_service_learning_experience",
  [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT]: "cp_f2027_community_engagement",
};

export const TEMPLATE_FIELD_TYPE_ACTION_TABLE = "ActionTable";
export const TEMPLATE_FIELD_TYPE_ACTION_TABLE_V2 = "ActionTableV2";

//Project submission accepted file types
export const PERSONAL_PROJECT_ACCEPTED_TYPES = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.google-apps.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  "application/vnd.google-apps.presentation",
  "application/pdf",
];
export const DP_EE_ACCEPTED_TYPES = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.google-apps.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  "application/vnd.google-apps.presentation",
  "application/pdf",
];
export const DP_TOK_ESSAY_ACCEPTED_TYPES = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.google-apps.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  "application/vnd.google-apps.presentation",
  "application/pdf",
];
export const DP_TOK_EXHIBITION_ACCEPTED_TYPES = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.google-apps.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  "application/vnd.google-apps.presentation",
  "application/pdf",
];

export const COMMUNITY_PROJECT_ACCEPTED_TYPES = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.google-apps.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
  "application/vnd.google-apps.presentation",
  "application/pdf",
];

// Filters options
export const FILTER_STATUS = "STATUS";
export const FILTER_PROJECT_GROUP_PORTFOLIO_ADVISOR =
  "PROJECT_GROUP_PORTFOLIO_ADVISOR";
export const FILTER_SUPERVISOR = "SUPERVISOR";
export const FILTER_STUDENT = "STUDENT";
export const FILTER_OVERALL_PROGRESS = "OVERALL_PROGRESS";
export const FILTER_COURSES = "COURSES";
export const FILTER_SUBJECT = "SUBJECT";
export const FILTER_PORTFOLIO_SUPERVISOR = "PORTFOLIO_SUPERVISOR"; // had to create a new case as a different query is used -->getStudentPortfolioSupervisorsQuery
export const FILTER_PROJECT_GROUP_SUPERVISOR = "INVITED_SUPERVISOR";
export const FILTER_PROJECT_GROUP_ADVISOR = "INVITED_ADVISOR";
export const FILTER_CAS_PROJECT_EXPERIENCE_TYPE = "PROJECT_EXPERIENCE_TYPE";
export const FILTER_LAST_MODIFIED = "LAST_MODIFIED";
export const FILTER_CURRICULUM_PROGRAM = "CURRICULUM_PROGRAM";
export const FILTER_PROJECT_CREATED_AT_ACADEMIC_YEAR =
  "CREATED_AT_ACADEMIC_YEAR";
export const FILTER_REGISTRATION_CATEGORY = "REGISTRATION_CATEGORY";
export const FILTER_DELETED_BY = "DELETED_BY";
export const FILTER_VIEW = "VIEW";
export const FILTER_PROJECT_GROUP_PORTFOLIO_STATUS =
  "PROJECT_GROUP_PORTFOLIO_STATUS";

//Project Roles
export const ROLE_ADMIN = "admin";
export const ROLE_SUPERVISOR = "supervisor";
export const ROLE_STUDENT = "student";

//Project Group by
export const PROJECT_PROGRESS_GROUP_BY_STATUS = "STATUS";
export const PROJECT_PROGRESS_GROUP_BY_SUPERVISOR = "SUPERVISOR";

// Project group sub-type

export const PROJECT_GROUP_SUB_TYPE_CORE = "CORE";
export const PROJECT_GROUP_SUB_TYPE_INTERNAL_ASSESSMENT = "INTERNAL_ASSESSMENT";
export const PROJECT_GROUP_SUB_TYPE_EXTERNAL_ASSESSMENT = "EXTERNAL_ASSESSMENT";
export const PROJECT_GROUP_SUB_TYPE_SUBJECT_GROUP_PROJECT =
  "SUBJECT_GROUP_PROJECT";

//Project Status
export const PROJECT_STATUS_PENDING_FOR_APPROVAL = "PENDING_FOR_APPROVAL";
export const PROJECT_STATUS_NOT_STARTED = "NOT_STARTED";
export const PROJECT_STATUS_DOING_GREAT = "DOING_GREAT";
export const PROJECT_STATUS_NOT_QUITE = "NOT_QUITE";
export const PROJECT_STATUS_IN_PROGRESS = "IN_PROGRESS";
export const PROJECT_STATUS_REVIEW_REQUESTED = "REVIEW_REQUESTED";
export const PROJECT_STATUS_COMPLETED = "COMPLETED";
export const PROJECT_STATUS_REJECTED = "REJECTED";
export const PROJECT_STATUS_POOR = "POOR";
export const PROJECT_STATUS_AVERAGE = "AVERAGE";
export const PROJECT_STATUS_GOOD = "GOOD";
export const PROJECT_STATUS_VERY_GOOD = "VERY_GOOD";
export const PROJECT_STATUS_APPROVED = "APPROVED";
export const PROJECT_STATUS_DRAFT = "DRAFT";

//Project Last modified
export const LAST_MODIFIED_TODAY = "LAST_ONE_DAY";
export const LAST_MODIFIED_LAST_SEVEN_DAYS = "LAST_SEVEN_DAYS";
export const LAST_MODIFIED_LAST_MONTH = "LAST_THIRTY_DAYS";
export const LAST_MODIFIED_ANYTIME = "ANYTIME";

//Project Report Status
export const PROJECT_REPORT_STATUS_PENDING = "PENDING";
export const PROJECT_REPORT_STATUS_SUBMITTED = "SUBMITTED";
export const PROJECT_REPORT_STATUS_APPROVED = "APPROVED";
export const PROJECT_REPORT_STATUS_IN_PROGRESS = "IN_PROGRESS";
export const PROJECT_REPORT_STATUS_NOT_STARTED = "NOT_STARTED";
export const PROJECT_REPORT_STATUS_NON_SUBMISSION = "NON_SUBMISSION";
export const PROJECT_REPORT_STATUS_PENDING_FOR_APPROVAL =
  "PENDING_FOR_APPROVAL";
export const PROJECT_REPORT_STATUS_REJECTED = "REJECTED";

// Portfolio Types
export const PORTFOLIO_EXPERIENCE = "EXPERIENCE";
export const PORTFOLIO_PROJECT = "PROJECT";

export const PROJECT = "PROJECT";

//Grade Constants

// Gradebook Constants
export const IB_PYP_ELEMENT_TYPE_DP = "DP_CRITERIA";
export const CRITERIA_RUBRIC_FINAL_GRADE = "CRITERIA_RUBRIC_FINAL_GRADE";
export const PROJECT_GROUP = "PROJECT_GROUP";

//IB PYP ELEMENT SUBTYPE
export const IB_PYP_ELEMENT_SUBTYPE_EE_FINAL_GRADE = "EE_FINAL_GRADE";
export const IB_PYP_ELEMENT_SUBTYPE_EE_FINAL_GRADE_2027 = "EE_FINAL_GRADE_2027";
export const IB_PYP_ELEMENT_SUBTYPE_RP_FINAL_GRADE = "RP_FINAL_GRADE";
export const IB_PYP_ELEMENT_SUBTYPE_RP_FINAL_GRADE_2027 = "RP_FINAL_GRADE_2027";

export const ATTACHMENT_TYPE_PROJECT_GROUP_SL_STIMULI =
  "PROJECT_GROUP_SL_STIMULI";
export const ATTACHMENT_TYPE_PROJECT_GROUP_HL_STIMULI =
  "PROJECT_GROUP_HL_STIMULI";

export const HL_LABEL = "HL";
export const SL_LABEL = "SL";

export const INTERNAL_ASSESSMENT_SHORT_LABEL = "IA";
export const EXTERNAL_ASSESSMENT_SHORT_LABEL = "EA";

export const DEFAULT_ARCHIVAL_STATE = "ALL";

// invite elements type constants
export const INVITE_ELEMENT_INVITE_USER = "invite";
export const INVITE_ELEMENT_PENDING_APPROVALS = "pending_approvals";
export const INVITE_ELEMENT_CREATE_INVITE_EXTERNAL_USER =
  "create_invite_external_supervisor";

// supervisor approval status

export const SUPERVISOR_APPROVAL_STATUS_PENDING = "PENDING";
export const SUPERVISOR_APPROVAL_STATUS_APPROVED = "APPROVED";
export const SUPERVISOR_APPROVAL_STATUS_REJECTED = "REJECTED";

// setup badge count entity type
export const PENDING_APPROVAL_SUPERVISOR_COUNT =
  "PENDING_APPROVAL_SUPERVISOR_COUNT";

// Batch files size and its modal config
export const FILE_DOWNLOAD_BATCH_SIZE = 15;

// student code length

export const FILES_BATCHING_MODAL_CONFIG = {
  userSettingName: "dontShowMultipleZipDownloadDialogue",
  modalTitleLabelLocale: "project:downloading_as_multiple_zip_files",
  modalBodyLabelLocale:
    "project:multiple_files_download_dialogue_text_with_label",
  displayDontShowAgainLabel: "true",
};

export const PROJECT_GROUP_ID_NOT_FOUND = "projectGroup_id_not_found";

// thirdPane tabs
export const PROJECT_REVIEW_LOG_THIRD_PANE = "PROJECT_REVIEW_LOG";

export const MODAL_Z_INDEX = 1100;

export const DEFAULT_FORM_LANGUAGE_OPTIONS = [
  {
    value: "en",
    labelLocale: "common:english",
  },
  {
    value: "fr",
    labelLocale: "common:french",
  },
  {
    value: "es",
    labelLocale: "common:spanish",
  },
];
// CAS external
export const CAS_EXTERNAL_USER_MODULE_NAME = "CreativityActivityService";
export const SNP_EXTERNAL_USER_MODULE_NAME = "SnPAuthorizationAndEvaluation";

export const PROJECT_SUPERVISOR_TYPE_INTERNAL = "INTERNAL";
export const PROJECT_SUPERVISOR_TYPE_EXTERNAL = "EXTERNAL";

// SUBMISSION MODES
export const SUBMISSION_MODE_GROUP_LEVEL = "GROUP_LEVEL";
export const SUBMISSION_MODE_INDIVIDUAL = "INDIVIDUAL";

// SPLITTING ENTITIES
export const ACADEMIC_HONESTY = "ACADEMIC_HONESTY";
export const REFLECTION = "REFLECTION";
export const ASSESSMENT = "ASSESSMENT";

// DURATION ENTITIES
export const EXPERIENCE_DURATION = "EXPERIENCE_DURATION";
export const ACTIVITY_DURATION = "ACTIVITY_DURATION";
export const INDIVIDUAL_STRANDS_DURATION = "INDIVIDUAL_STRANDS_DURATION";
export const MAX_DURATION_HOURS = "MAX_DURATION_HOURS";

// Based on route what setting to check
export const ROUTE_KEY_ENTITY_MAP = {
  "academic-honesty": ACADEMIC_HONESTY,
  reflecting: REFLECTION,
  assessment: ASSESSMENT,
  guidingQuestions: REFLECTION,
};

export const PROJECT_GROUP_DEADLINES_ORDER_ENTITY_TYPE = "DEADLINE_DATE";
export const PROJECT_GROUP_DEADLINES_ORDER_DIRECTION = "ASC";

// invite steps constants
export const INVITE_STEP_EXTERNAL_SUPERVISOR = "externalSupervisor";

// open/close animation time for the right pane
export const RIGHT_PANE_ANIMATION_TIME = 300;
// personal project guides file names
export const PERSONAL_PROJECT_SUPERVISOR_HANDBOOK_2021 =
  "Personal_Project_Supervisor_Handbook_2021.pdf";
export const PERSONAL_PROJECT_GUIDE_2021 = "Personal_project_guide_2021.pdf";
export const PERSONAL_PROJECT_TEACHER_SUPPORT_MATERIAL =
  "Personal_project_teacher_support_material.pdf";
export const PERSONAL_PROJECT_STUDENT_HANDBOOK_2021 =
  "Personal_Project_Student_Handbook_2021.pdf";

// community project guides file names
export const COMMUNITY_PROJECT_GUIDANCE_COORDINATORS_SUPERVISORS =
  "Community_Project_Guidance_Coordinators_Supervisors.docx";
export const COMMUNITY_PROJECT_GUIDE = "Community_project_guide.pdf";
export const COMMUNITY_PROJECT_TEACHER_SUPPORT_MATERIAL =
  "Community_project_teacher_support_material.pdf";
export const COMMUNITY_PROJECT_CASE_STUDY = "Community_Project_Case_Study.pdf";
export const COMMUNITY_PROJECT_STUDENT_HANDBOOK =
  "Community_Project_Student_Handbook.pptx";
export const COMMUNITY_PROJECT_SELF_PEER_ASSESSMENT =
  "Community_Project_Self_peer_assessment.docx";

// CAS guides file names
export const CAS_ADVISORS_HANDBOOK_DP_V2 = "CAS_Advisors_Handbook_DP_V2.pptx";
export const CAS_IB_GUIDE_2017 = "CAS_IB_GUIDE_2017.pdf";
export const CAS_STUDENTS_HANDBOOK_DP_V2 = "CAS_Students_Handbook_DP_V2.pptx";
export const CAS_COORDINATORS_HANDBOOK_DP_V2 =
  "CAS_Coordinators_Handbook_DP_V2.pptx";
export const CAS_RISK_ASSESSMENT_FORM_V2 = "CAS_Risk_assessment_form_V2.docx";

// SL guides file names
export const GUIDE_SERVICE_LEARNING_2016 = "Guide_Service_Learning_2016.pdf";

// CE guide filenames
export const GUIDE_COMMUNITY_ENGAGEMENT_2027 =
  "Guide_Community_Engagement_2027.pdf";

// extended essay guides file names
export const EXTENDED_ESSAY_HANDBOOK_STUDENTS_V2 =
  "Extended_Essay_Handbook_Students_V2.pptx";
export const EXTENDED_ESSAY_HANDBOOK_STUDENTS_2027 =
  "Extended_Essay_Handbook_Students_V3.pptx";
export const EXTENDED_ESSAY_ANNOTATED_RPPF =
  "Extended_Essay_Annotated_RPPF.pdf";
export const GUIDE_EXTENDED_ESSAY_2018 = "Guide_Extended_essay_2018.pdf";
export const GUIDE_EXTENDED_ESSAY_2027 = "Guide_Extended_essay_2027.pdf";
export const EXTENDED_ESSAY_HANDBOOK_SUPERVISORS_V2 =
  "Extended_Essay_Handbook_Supervisors_V2.pptx";
export const EXTENDED_ESSAY_HANDBOOK_SUPERVISORS_2027 =
  "Extended_Essay_Handbook_Supervisors_V3.pptx";
export const EXTENDED_ESSAY_HANDBOOK_COORDINATORS =
  "Extended_Essay_Handbook_Coordinators.pptx";
export const EXTENDED_ESSAY_HANDBOOK_COORDINATORS_2027 =
  "Extended_Essay_Handbook_Coordinators_v2.pptx";

// toks guides file names
export const TOK_PLANNING_AND_PROGRESS_FORM_EXEMPLAR =
  "TOK_Planning_and_progress_form_Exemplar.pdf";
export const TOK_ESSAY_EXEMPLAR = "TOK_Essay_Exemplar.pdf";
export const TOK_IN_ACTION_HANDBOOK_DP = "TOK_In_Action_Handbook_DP.pptx";
export const TOK_ASSESSMENT_HANDBOOK_DP = "TOK_Assessment_Handbook_DP.pptx";
export const TOK_GUIDE_2022 = "TOK_guide_2022.pdf";
export const TOK_EXHIBITION_COMMENTARY_EXEMPLAR =
  "TOK_Exhibition_Commentary_Exemplar.pdf";

// reflective project guides file names
export const GUIDE_REFLECTIVE_PROJECT_2016 =
  "Guide_Reflective_Project_2016.pdf";

export const GUIDE_REFLECTIVE_PROJECT_2027 = "Reflective project - FA 2027.pdf";

// journal, portfolio feedback and interviews upload options
export const PROJECTS_JOURNALS_AND_INTERVIEWS_UPLOAD_OPTIONS = [
  { key: "capture_voice", label: "common:record_audio" },
  { key: "upload_device", label: "common:upload_device" },
  { key: "add_google_drive", label: "common:add_google_drive" },
  { key: "add_one_drive", label: "common:add_one_drive" },
  { key: "add_link", label: "common:add_link" },
];

export const PROJECT_GROUP_CONFIGURATION_SETTINGS_NAME_MAP = {
  [PROJECT_GROUP_TYPE_COMMUNITY]: "SplitEntitiesStudentWiseInProjectGroup",
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]:
    "SplitEntitiesStudentWiseInProjectGroup",
  [PROJECT_GROUP_TYPE_DP_CAS]: "ProjectPortfolioDurationsSettings",
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: "ProjectPortfolioDurationsSettings",
  [PROJECT_GROUP_TYPE_DP_EE]: "AssessmentPageSettingsInProjects",
  [PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION]: "AssessmentPageSettingsInProjects",
  [PROJECT_GROUP_TYPE_DP_TOK_ESSAY]: "AssessmentPageSettingsInProjects",
  [PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT]:
    "AssessmentPageSettingsInProjects",
  [PROJECT_GROUP_TYPE_PERSONAL]: "AssessmentPageSettingsInProjects",
};

// field uids
export const FORM_SUPERVISOR_UID = "formSupervisor";
export const CAS_STRANDS_UID = "CASStrands";
export const SL_STRANDS_UID = "serviceActionTypeCP_SL";
export const STRANDS_DURATION_UID = "strandsDuration";
export const SUPERVISION_HOURS_UID = "supervisionHours";
export const SAA_STRANDS_UID = "serviceActionTypeMYP";
export const CAREER_RELATED_STUDY_UID = "careerRelatedStudy";
export const TOK_THEME = "TOKTheme";

// project portfolio duration
export const EXPERIENCE = "EXPERIENCE";
export const CREATIVITY = "CREATIVITY";
export const ACTIVITY = "ACTIVITY";
export const SERVICE = "SERVICE";
export const DIRECT_SERVICE = "DIRECT_SERVICE";
export const INDIRECT_SERVICE = "INDIRECT_SERVICE";
export const ADVOCACY = "ADVOCACY";
export const RESEARCH = "RESEARCH";

export const DEFAULT_CAS_EXPERIENCE_DURATION = 150;
export const DEFAULT_SL_EXPERIENCE_DURATION = 50;
export const DEFAULT_SAA_ACTIVITY_DURATION = 40;
export const DEFAULT_INDIVIDUAL_CAS_STRAND_DURATION = 50;
export const DEFAULT_INDIVIDUAL_SL_STRAND_DURATION = 12;
export const DEFAULT_INDIVIDUAL_SAA_STRAND_DURATION = 10;

// portfolio insights tables types
export const STATUS_OF_EXPERIENCES = "STATUS_OF_EXPERIENCES";
export const HOURLY_PROGRESS = "HOURLY_PROGRESS";

export const STATUS_WISE_EXPERIENCE_DISTRIBUTION =
  "STATUS_WISE_EXPERIENCE_DISTRIBUTION";
export const DURATION_WISE_EXPERIENCE_DISTRIBUTION =
  "DURATION_WISE_EXPERIENCE_DISTRIBUTION";

export const PORTFOLIO_STRANDS_MAPPING = {
  [PROJECT_GROUP_TYPE_DP_CAS]: {
    CREATIVITY: {
      id: "creativity",
      value: "creativity",
      abbreviation: "C",
      subType: "CREATIVITY",
      label: "project:creativity",
      color: "var(--decorative-foreground-subtle-teal)",
    },
    ACTIVITY: {
      id: "activity",
      value: "activity",
      abbreviation: "A",
      subType: "ACTIVITY",
      label: "project:activity",
      color: "var(--decorative-foreground-subtle-pink)",
    },
    SERVICE: {
      id: "service",
      value: "service",
      abbreviation: "S",
      subType: "SERVICE",
      label: "project:service",
      color: "var(--decorative-foreground-subtle-purple)",
    },
  },
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: {
    DIRECT_SERVICE: {
      id: "directService",
      value: "directService",
      abbreviation: "DS",
      subType: "DIRECT_SERVICE",
      label: "project:direct_service",
      color: "var(--decorative-foreground-subtle-teal)",
    },
    INDIRECT_SERVICE: {
      id: "indirectService",
      value: "indirectService",
      abbreviation: "IS",
      subType: "INDIRECT_SERVICE",
      label: "project:indirect_service",
      color: "var(--decorative-foreground-subtle-violet)",
    },
    ADVOCACY: {
      id: "advocacy",
      value: "advocacy",
      abbreviation: "A",
      subType: "ADVOCACY",
      label: "project:advocacy",
      color: "var(--decorative-foreground-subtle-purple)",
    },
    RESEARCH: {
      id: "research",
      value: "research",
      abbreviation: "R",
      subType: "RESEARCH",
      label: "project:research",
      color: "var(--decorative-foreground-subtle-pink)",
    },
  },
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: {
    DIRECT_SERVICE: {
      id: "directService",
      value: "directService",
      abbreviation: "DS",
      subType: "DIRECT_SERVICE",
      label: "project:direct_service",
      color: "var(--decorative-foreground-subtle-teal)",
    },
    INDIRECT_SERVICE: {
      id: "indirectService",
      value: "indirectService",
      abbreviation: "IS",
      subType: "INDIRECT_SERVICE",
      label: "project:indirect_service",
      color: "var(--decorative-foreground-subtle-violet)",
    },
    ADVOCACY: {
      id: "advocacy",
      value: "advocacy",
      abbreviation: "A",
      subType: "ADVOCACY",
      label: "project:advocacy",
      color: "var(--decorative-foreground-subtle-purple)",
    },
    RESEARCH: {
      id: "research",
      value: "research",
      abbreviation: "R",
      subType: "RESEARCH",
      label: "project:research",
      color: "var(--decorative-foreground-subtle-pink)",
    },
  },
};

export const PORTFOLIO_STATUS_MAPPING = {
  COMPLETED: {
    id: "COMPLETED",
    label: "common:completed",
    color: "var(--teal-600)",
  },

  APPROVED: {
    id: "APPROVED",
    label: "common:approved",
    color: "var(--yellow-600)",
  },
  DRAFT: {
    id: "DRAFT",
    label: "common:draft",
    color: "var(--orange-600)",
  },
};

// Assessment page settings for projectGroups
export const ASSESSMENT_SETTINGS = "ASSESSMENT_SETTINGS";
export const RECORD_SUPERVISION_HOURS = "RECORD_SUPERVISION_HOURS";
export const ALLOW_STUDENTS_TO_VIEW_ASSESSMENT =
  "ALLOW_STUDENTS_TO_VIEW_ASSESSMENT";

export const OVERVIEW = "OVERVIEW";
export const LEARNING_OUTCOMES_PROGRESS = "LEARNING_OUTCOMES_PROGRESS";
export const STRANDS_PROGRESS = "STRANDS_PROGRESS";

// portfolio insights revamp map
export const PORTFOLIO_INSIGHTS_PROJECT_GROUP_TYPE_MAPPING = {
  [PROJECT_GROUP_TYPE_DP_CAS]: {
    perm: "FeatureFlag:casPortfolioInsightsRevamp",
    pseudoFieldUids: ["CASStrands", "strandsDuration", "projectDuration"],
    strandPlannerElementId: "DP_CAS_STRANDS",
    strandFieldUid: "CASStrands",
    loFieldUid: "casLearningOutcomes",
    strandsDurationStepLabel: "project:cas_strands_and_duration_step_label",
    studentPortfolioStrandsHourlyProgressTableDetails: {
      heading:
        "project:student_portfolio_cas_strands_distribution_table_heading",
      subtext:
        "project:student_portfolio_cas_strands_distribution_table_subtext",
    },
    stagesToggleUID: "casStagesToggle",
    studentPortfolioStrandsProgressTableDetails: {
      heading: "project:student_portfolio_cas_strands_progress_table_heading",
      subtext:
        "project:student_portfolio_cas_strands_distribution_table_subtext",
    },
    projectLabelPlural: "project:experience_plural",
    projectLabel: "project:experience",
    strandLabelLocale: "common:strand_plural",
    plannerElementSets: [
      PLANNER_ELEMENT_DP_CAS_SERVICE_TYPES,
      PLANNER_ELEMENT_DP_CAS_STRANDS,
      PLANNER_ELEMENT_DP_CAS_APPROACHES,
    ],
  },
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: {
    perm: "FeatureFlag:slPortfolioInsightsRevamp",
    pseudoFieldUids: [
      "serviceActionTypeCP_SL",
      "strandsDuration",
      "projectDuration",
    ],
    strandPlannerElementId: "DP_CP_SL_STRANDS",
    strandFieldUid: "serviceActionTypeCP_SL",
    loFieldUid: "slLearningOutcomes",
    strandsDurationStepLabel: "project:sl_strands_and_duration_step_label",
    studentPortfolioStrandsHourlyProgressTableDetails: {
      heading:
        "project:student_portfolio_sl_strands_distribution_table_heading",
      subtext:
        "project:student_portfolio_sl_strands_distribution_table_subtext",
    },
    stagesToggleUID: "slStagesToggle",
    studentPortfolioStrandsProgressTableDetails: {
      heading: "project:student_portfolio_sl_strands_progress_table_heading",
      subtext:
        "project:student_portfolio_sl_strands_distribution_table_subtext",
    },
    projectLabelPlural: "project:experience_plural",
    projectLabel: "project:experience",
    strandLabelLocale: "project:service_action_types",
    plannerElementSets: [
      PLANNER_ELEMENT_DP_CP_SL_APPROACHES,
      PLANNER_ELEMENT_DP_CP_SL_STRANDS,
    ],
  },
  [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT]: {
    perm: "FeatureFlag:slPortfolioInsightsRevamp",
    pseudoFieldUids: [
      "serviceActionTypeCP_SL",
      "strandsDuration",
      "projectDuration",
    ],
    loFieldUid: "ceLearningOutcomes",
    stagesToggleUID: "slStagesToggle",
    studentPortfolioLOProgressTableDetails: {
      heading: "project:student_progress",
      subtext: "project:student_portfolio_lo_distribution_table_subtext",
      headingTypography: "text-heading-5",
      containerStyle: {
        marginTop: 0,
      },
    },
    projectLabelPlural: "project:engagement_plural",
    projectLabel: "project:engagement",
    plannerElementSets: [],
  },
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: {
    strandsDurationStepLabel: "project:saa_strands_and_duration_step_label",
    pseudoFieldUids: [
      "serviceActionTypeMYP",
      "strandsDuration",
      "activityDuration",
    ],
    strandPlannerElementId: "MYP_SERVICE_ACTION_TYPE",
    strandFieldUid: "serviceActionTypeMYP",
    loFieldUid: "serviceActionOutcomeMYP",
    studentPortfolioStrandsHourlyProgressTableDetails: {
      heading:
        "project:student_portfolio_saa_strands_distribution_table_heading",
      subtext:
        "project:student_portfolio_saa_strands_distribution_table_subtext",
    },
    studentPortfolioStrandsProgressTableDetails: {
      heading: "project:student_portfolio_saa_strands_progress_table_heading",
      subtext:
        "project:student_portfolio_saa_strands_distribution_table_subtext",
    },
    projectLabelPlural: "project:activity_plural",
    projectLabel: "project:activity",
    strandLabelLocale: "project:service_action_types",
    plannerElementSets: [PLANNER_ELEMENT_MYP_SERVICE_ACTION_TYPE],
  },
};

// step Ids
export const ASSESSMENT_V2_STEP_ID = "assessmentv2";
export const ASSESSMENT_STEP_ID = "assessment";

export const PROJECT_FINAL_GRADE = "PROJECT_FINAL_GRADE";
export const PROJECT_FINAL_SCORE = "PROJECT_FINAL_SCORE";
export const PROJECT_GRADEBOOK = "PROJECT_GRADEBOOK";

export const RECOMMENDED_HOURS_MAP = {
  [PROJECT_GROUP_TYPE_PERSONAL]: 25,
  [PROJECT_GROUP_TYPE_COMMUNITY]: 15,
};

export const MYP_OBJECTIVES = "MYP_OBJECTIVES";

// Download nomenclature
export const STUDENT_NAME = "STUDENT_NAME";
export const SUBMISSION_ITEM = "SUBMISSION_ITEM";
export const NO_GROUPING = "NO_GROUPING";

export const DOWNLOAD_OPTIONS_FILE_FORMAT = {
  [STUDENT_NAME]:
    "{{submissionItemName}}_{{studentName}} ({{studentUID}})_{{level}}",
  [SUBMISSION_ITEM]:
    "{{studentName}} ({{studentUID}})_{{level}}_{{submissionItemName}}",
  [NO_GROUPING]:
    "{{studentName}} ({{studentUID}})_{{level}}_{{submissionItemName}}",
};

export const RATING_REFRESH_PAGE_ERROR =
  "ABAC: Refresh the page to continue rating";

export const REFRESH_PAGE_ERROR = "ABAC: Refresh the page to continue";

// project details header
export const PROJECT_DETAILS_HEADER_FIELD_FILTERS = {
  [PROJECT_GROUP_TYPE_DP_CAS]: {
    pseudoFieldUids: [
      "supervisorType",
      "supervisorEmail",
      "supervisor",
      "supervisorOrganisation",
      "supervisorPhone",
      "title",
      "image",
    ],
  },
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: {
    pseudoFieldUids: [
      "supervisorType",
      "supervisorEmail",
      "supervisor",
      "supervisorOrganisation",
      "supervisorPhone",
      "title",
      "image",
    ],
  },
  [PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT]: {
    pseudoFieldUids: [
      "supervisorType",
      "supervisorEmail",
      "supervisor",
      "supervisorOrganisation",
      "supervisorPhone",
      "title",
      "image",
    ],
  },
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: {
    pseudoFieldUids: [
      "title",
      "supervisorType",
      "supervisorEmail",
      "supervisor",
      "supervisorOrganisation",
      "supervisorPhone",
    ],
  },
  [PROJECT_GROUP_TYPE_COMMUNITY]: {
    pseudoFieldUids: ["title"],
  },
  [PROJECT_GROUP_TYPE_DP_G4_PROJECT]: {
    pseudoFieldUids: ["title"],
  },
  [PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT]: {
    pseudoFieldUids: ["title", "topic"],
  },
};

export const MULTIPLE_STUDENTS_PROJECT_GROUPS_LIST = [
  PROJECT_GROUP_TYPE_COMMUNITY,
  PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
  PROJECT_GROUP_TYPE_DP_CAS,
  PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING,
  PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT,
  PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT,
  PROJECT_GROUP_TYPE_DP_G4_PROJECT,
];

export const PROGRESS = "progress";

export const PROJECT_DASHBOARD = "PROJECT_DASHBOARD";
export const PROJECT_OVERALL_PROGRESS_CRITERIA_TYPE =
  "PROJECT_OVERALL_PROGRESS";
export const PROJECT_LEARNING_OUTCOME_CRITERIA_TYPE = "LEARNING_OUTCOME_LEVEL";

export const PROJECTS_ENABLE_REJECTION_STATUS_PERM =
  "FeatureFlag:EnableRejectionStatusInProjects";

export const PROJECT_SETTINGS_MIGRATION_PERM =
  "FeatureFlag:YearGroupAdminPortalMigration";

export const CAN_MANAGE_IA_EA_PERMISSION =
  "Iaea:CanManageInternalExternalAssessments";

export const MANAGE_SETUP_AND_ALL_STUDENT_PROJECTS_PERMISSION =
  "Projects:CanViewAndManageProjectSetupAndAllStudentProjects";

export const ENABLE_PROJECTS_FOR_FAMILY = "Common:EnableProjectsForFamily";

// ARCHIVE / UNARCHIVE STATUSES
export const ARCHIVE = "ARCHIVE";
export const UNARCHIVE = "UNARCHIVE";

// deadline submisison status constants
export const TURNED_IN_ON_TIME = "TURNED_IN_ON_TIME";
export const TURNED_IN_LATE = "TURNED_IN_LATE";
export const SUBMISSION_PENDING = "SUBMISSION_PENDING";
export const REQUEST_RESUBMISSION = "REQUEST_RESUBMISSION";
export const REQUEST_RESUBMISSION_OVERDUE = "REQUEST_RESUBMISSION_OVERDUE";

export const OVERDUE = "OVERDUE";
export const NOT_SUBMITTED = "NOT_SUBMITTED";
export const RESUBMISSION_NOT_SUBMITTED = "RESUBMISSION_NOT_SUBMITTED";

export const ALL_STUDENTS = "ALL_STUDENTS";
export const DEADLINE_COMPLETED = "DEADLINE_COMPLETED";

// deadline submissionType

export const SUBMISSION_TYPE_IB_DEFINED = "IB_DEFINED";
export const SUBMISSION_TYPE_CUSTOM = "CUSTOM";
export const SUBMISSION_TYPE_DRAFT = "DRAFT";
export const SUBMISSION_TYPE_FINAL = "FINAL";

export const PROJECT_GROUP_SUBMISSION_ITEM_TEMPLATE =
  "PROJECT_GROUP_SUBMISSION_ITEM_TEMPLATE";
export const SUBMISSION_ITEM_CUSTOM_FIELD_UID = "custom_default";

// Project Group Category Types for generalization
export const PROJECT_GROUP_CATEGORY_TYPE_PORTFOLIO = "PORTFOLIO_PROJECT";
export const PROJECT_GROUP_CATEGORY_TYPE_SUBJECT = "SUBJECT_PROJECT";

// SAA portfolio revamp perm
export const SAA_PORTFOLIO_REVAMP_PERM = "FeatureFlag:SAAPortfolioRevamp";

export const DEADLINES_REVAMP_BANNER_TYPE = "DEADLINES_REVAMP_BANNER";

export const DEADLINES_ALERT_BANNER_SETTING = "DeadlinesAlertBanner";

export const SAA_QUESTIONS_SETUP_ALERT_BANNER_SETTING =
  "SaaReflectionQuestionsBanner";

export const OVERALL_PROGRESS_HISTORY_TYPE = "OVERALL_PROGRESS_HISTORY";
export const LO_PROGRESS_GRADEBOOK_TYPE = "LO_PROGRESS_GRADEBOOK";
export const LO_PROGRESS_HISTORY_TYPE = "LO_PROGRESS_HISTORY";

export const COMMUNITY_ENGAGEMENT_DIMENSIONS = "CE_DIMENSIONS";
export const COMMUNITY_ENGAGEMENT_STAGES = "CE_STAGES";
export const COMMUNITY_ENGAGEMENT_PRINCIPLES = "CE_PRINCIPLES";

export const TURN_IN_MODAL = "TURN_IN_MODAL";

export const INDICATOR_COLOR_FOR_SELECTION = [
  "var(--violet-950)",
  "var(--yellow-950)",
  "var(--blue-950)",
  "var(--pink-950)",
  "var(--purple-950)",
  "var(--green-950)",
  "var(--orange-950)",
  "var(--red-950)",
  "var(--neutral-white)",
];

export const INDICATOR_COLORS_MAPPING_GRADEBOOK = {
  ["var(--violet-950)"]: "#F3F3FF",
  ["var(--yellow-950)"]: "#FFF8E5",
  ["var(--blue-950)"]: "#E5FBFD",
  ["var(--pink-950)"]: "#FFF0F6",
  ["var(--purple-950)"]: "#FAF1FE",
  ["var(--green-950)"]: "#F4F9E7",
  ["var(--orange-950)"]: "#FFF2EE",
  ["var(--red-950)"]: "#FFEFEF",
  ["var(--neutral-white)"]: "#FFF",
};

export const INDICATOR_BORDER_STROKE = {
  ["var(--violet-950)"]: "var(--violet-900)",
  ["var(--yellow-950)"]: "var(--yellow-900)",
  ["var(--blue-950)"]: "var(--blue-900)",
  ["var(--pink-950)"]: "var(--pink-900)",
  ["var(--purple-950)"]: "var(--purple-900)",
  ["var(--green-950)"]: "var(--green-900)",
  ["var(--orange-950)"]: "var(--orange-900)",
  ["var(--red-950)"]: "var(--red-900)",
  ["var(--neutral-white)"]: "var(--border-secondary)",
};

export const PROJECT_GROUP_ORDER = {
  [PROJECT_GROUP_TYPE_DP_CAS]: 1,
  [PROJECT_GROUP_TYPE_DP_EE]: 2,
  [PROJECT_GROUP_TYPE_DP_TOK_ESSAY]: 3,
  [PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION]: 4,
  [PROJECT_GROUP_TYPE_PERSONAL]: 5,
  [PROJECT_GROUP_TYPE_COMMUNITY]: 6,
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: 7,
};
